'use strict';

/* globals $, Klarna */

const CHECKOUT_LOCATION = 'checkout';
const EXPRESS_CHECKOUT_CLICK = 'express checkout click';
const EXPRESS_CHECKOUT = 'express checkout';
const PAYMENT_INTERACTION_EVENT = 'payment_info_interaction';
const KLARNA_TEXT = 'klarna';	
const tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('base_global/utils');
function klarnaExpress() {
    $(".klarna-express-checkout-container.klarnamaindiv").click(function(e){
        var checkoutMethod = 'klarna express';
        let $klarnaButton = $('klarna-express-button');
        var subTotal = $('.totals .sub-total').html();
        var totalItems = $('.cart-header__description').data('tealiumitemquantity') || $('.summary-count-wrapper .summary-item-count').data('numitems');
        var initiateCheckoutData = $('.checkoutanalyticscta').data('checkoutanalyticsdata');
        let queryParams = utils.getQueryStringParams(window.location.href);
        if (!('proceedrememberedGuestUser' in queryParams && queryParams.proceedrememberedGuestUser) && utils.expressButtonSessionTimeout()) {
            // checking if session expried
            return false;
        }

        tealiumEnable.getAnalyticsData('initiateRegularCheckout', checkoutMethod, initiateCheckoutData, subTotal, totalItems);
        if ($klarnaButton.length) {
            // Triggering klarna express button click
            $klarnaButton.removeClass('is-disabled');
            $($klarnaButton[0].shadowRoot).find('button#klarna-express-button').trigger('click');
        }
    });
    window.klarnaExpressButtonAsyncCallback = function () {
        (function () {
            Klarna.ExpressButton.on('user-authenticated', function (callbackData) {
                console.log("callbackData from klarna:");
                console.log(callbackData);
                var $klarnaForm = $('.klarna-express-form');
                if ($klarnaForm.length > 0 && callbackData && callbackData.address) {
                    // clear previous values
                    $klarnaForm.find('.klarna-express-input').val('');

                    $klarnaForm.find('[name$="_email"]').val(callbackData.email);
                    $klarnaForm.find('[name$="_phone"]').val(callbackData.phone);
                    $klarnaForm.find('[name$="_billingphone"]').val(callbackData.phone);
                    $klarnaForm.find('[name$="_firstName"]').val(callbackData.first_name);
                    $klarnaForm.find('[name$="_lastName"]').val(callbackData.last_name);
                    $klarnaForm.find('[name$="_address1"]').val(callbackData.address.street_address);
                    $klarnaForm.find('[name$="_address2"]').val(callbackData.address.street_address2 || '');
                    $klarnaForm.find('[name$="_city"]').val(callbackData.address.city);
                    $klarnaForm.find('[name$="_stateCode"]').val(callbackData.address.region);
                    $klarnaForm.find('[name$="_postalCode"]').val(callbackData.address.postal_code);
                    $klarnaForm.find('[name$="_countryCode"]').val(callbackData.address.country);

                    $klarnaForm.submit();
                }
            });
        }(jQuery));
};
}
module.exports = klarnaExpress;
